let instance = null;
let jsonLanguage = {};

export class Singleton {
  constructor() {
    if (!instance) {
      instance = this;
    }
    this.current_Language = '-1';
    return instance;
  }
  setLanguage(c_language) {
    this.current_Language = c_language;
  }
  getLanguage() {
    return this.current_Language;
  }
  getText(key) {
    return jsonLanguage[key];
  }
  jsonGut(jsonObject, father = '') {
    let propValue;
    let key;
    for (let propName in jsonObject) {
      propValue = jsonObject[propName]
      if (this.typeOf(propValue) === 'string') {
        switch (propValue.toLowerCase()) {
          case "january":
          case "enero":
            jsonLanguage['January'] = propValue;
            break;
          case "february":
          case "febrero":
            jsonLanguage['February'] = propValue;
            break;
          case "march":
          case "marzo":
            jsonLanguage['March'] = propValue;
            break;
          case "april":
          case "abril":
            jsonLanguage['April'] = propValue;
            break;
          case "may":
          case "mayo":
            jsonLanguage['May'] = propValue;
            break;
          case "june":
          case "junio":
            jsonLanguage['June'] = propValue;
            break;
          case "july":
          case "julio":
            jsonLanguage['July'] = propValue;
            break;
          case "august":
          case "agosto":
            jsonLanguage['August'] = propValue;
            break;
          case "september":
          case "septiembre":
            jsonLanguage['September'] = propValue;
            break;
          case "october":
          case "octubre":
            jsonLanguage['October'] = propValue;
            break;
          case "november":
          case "noviembre":
            jsonLanguage['November'] = propValue;
            break;
          case "december":
          case "diciembre":
            jsonLanguage['December'] = propValue;
            break;
          default:
            key = father + propName;
            key = key.replace("parameters", "");
            key = key.replace("Internacionlizacion", "");
            jsonLanguage[key] = propValue;
            break;
        }
      } else {
        this.jsonGut(propValue, father + propName);
      }
    }
  }
  jsonAlert(jsonAlert) {
    let propValue;
    for (let propName in jsonAlert['catalogueAlert']['Alert']) {
      propValue = jsonAlert['catalogueAlert']['Alert'][propName]
      jsonLanguage['alert-' + propValue['code']] = propValue['message'];
    }
  }
  jsonError(jsonError) {
    let propValue;
    for (let propName in jsonError['catalogueError']['error']) {
      propValue = jsonError['catalogueError']['error'][propName]
      jsonLanguage['error-' + propValue['code']] = propValue['message'];
    }
  }
  setJsonLanguage(json) {
    jsonLanguage = {}
    this.jsonGut(json.Response[0]);
    this.jsonAlert(json.Response[1]);
    this.jsonError(json.Response[2]);
  }
  typeOf(obj) {
    return {}.toString.call(obj).split(' ')[1].slice(0, -1).toLowerCase();
  }
}
